module.exports = __webpack_public_path__ + "img/bg1.f15d5ef7.png";